module.exports = __webpack_public_path__ + "static/media/mpcas.9f355249.png";